const config =  {
  apiEndpoints: {        
    //new
    usersUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/users/'),
    barOrderReportUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/barorders/'),
    barOrderPaymentReportUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/barorderpayments/'),
    barOrderItemsReportUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/barorders/items/'),
    barOrderItemCategoriesReportUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/barorders/categories/'),
    devicesUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/devices'),
    cashiersUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/cashiers'),
    salesUsersUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/baroders/users'),
    eventsUri: process.env.VUE_APP_API_GATEWAY_URI.concat('api/events'),
    viaCepUri: process.env.VUE_APP_VIACEP_URI
  },
  currentPartnerKey: '55PASS',
  partnersConfiguration: {},
  partnersList: [
    {
      key: '55PASS',
      name: '55Pass',
      apptitle: 'Dashboard',
      images: {
        header: {
          width: 125
        }
      },
      login: {
        type: 'default'
      }     
    }
  ],
  currentPartner: function() {
    const self = this;
    return this.partnersList.find(function (el) {
      return el.key == self.currentPartnerKey; 
    });
  }
}

config.partnersConfiguration = config.currentPartner();
export {config as default};

